import { render } from "./LandingPage.vue?vue&type=template&id=6906bc10"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=6906bc10&lang=scss"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-landing-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__